import { render, staticRenderFns } from "./aboutUsBanner.vue?vue&type=template&id=d143bb90&scoped=true"
import script from "./aboutUsBanner.vue?vue&type=script&lang=js"
export * from "./aboutUsBanner.vue?vue&type=script&lang=js"
import style0 from "./aboutUsBanner.vue?vue&type=style&index=0&id=d143bb90&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d143bb90",
  null
  
)

export default component.exports